export default __webpack_public_path__ + "static/blackcliff_longsword-e27682ad5f8a9f840b016072bffa9475.png";